/**
 * Terms & Conditions — Micropincher
 * Update version and lastUpdated on every content change.
 * This file is versioned in git — each change is traceable.
 */
const terms = {
  version: '1.0',
  lastUpdated: '2026-02-23',
  title: 'Terms & Conditions',
  sections: [
    {
      title: '1. Acceptance of Terms',
      paragraphs: [
        'By accessing or using Micropincher ("the Service", "the Platform"), you agree to be bound by these Terms & Conditions. If you do not agree, do not use the Service.',
        'These terms apply to all users, including visitors, registered free users, and paid subscribers.',
      ],
    },
    {
      title: '2. Description of Service',
      paragraphs: [
        'Micropincher is a decision-support tool and trading simulator for crypto traders. It provides analysis of arbitrage opportunities, funding rates, order book data, and trade simulation.',
        'The Service is provided for informational and educational purposes only. It is not a trading platform and does not execute trades on your behalf.',
        'All customer complaints and questions are handled exclusively in written form. Response time is not guaranteed. The primary channel for written communication is our Discord server. Alternatively, you may contact us by email at info@micropincher.com.',
      ],
    },
    {
      title: '3. Not Financial Advice',
      paragraphs: [
        'Nothing on Micropincher constitutes financial advice, investment advice, trading advice, or any other type of advice. All content is for informational purposes only.',
        'Micropincher does not guarantee profits. Past simulated results do not guarantee future real-world performance. You are solely responsible for your own trading decisions.',
        'Always consult a qualified financial advisor before making investment decisions.',
      ],
    },
    {
      title: '4. Account Registration',
      paragraphs: [
        'To access certain features, you must register using a Google account. You are responsible for maintaining the security of your account.',
        'You agree to provide accurate and complete information. Micropincher reserves the right to suspend or terminate accounts that violate these terms.',
        'By signing in, you consent to receiving service-related communications. We do not send unsolicited marketing emails.',
      ],
    },
    {
      title: '5. Subscription Plans & Billing',
      paragraphs: [
        'Micropincher offers the following plans:',
      ],
      list: [
        'Free Plan — no charge, limited features',
        'Monthly Plan — $15.00 USD per month, billed monthly',
        'Annual Plan — $150.00 USD per year, billed annually',
      ],
      paragraphsAfterList: [
        'Payments are processed by Stripe. By subscribing, you authorise Stripe to charge your payment method on a recurring basis according to your chosen plan.',
        'Prices may change with 30 days prior notice sent to your registered email address.',
      ],
    },
    {
      title: '6. Cancellation & Refunds',
      paragraphs: [
        'You may cancel your subscription at any time through the user menu in the application. Cancellation takes effect at the end of the current billing period — you retain full access until then.',
        'We do not offer refunds for partially used billing periods. If you cancel a monthly subscription mid-month, you keep access until the month ends but will not be refunded.',
        'In exceptional circumstances (e.g. technical failure preventing access for an extended period), refund requests may be submitted to info@micropincher.com and will be reviewed on a case-by-case basis.',
      ],
    },
    {
      title: '7. API Keys & Security',
      paragraphs: [
        'If you connect exchange API keys, you must use read-only keys. Micropincher does not require and should never be granted trading or withdrawal permissions.',
        'API keys are encrypted at rest. Micropincher cannot and will not execute trades or move funds from your exchange accounts.',
        'You are responsible for the security of the API keys you provide. Revoke and regenerate keys immediately if you suspect compromise.',
      ],
    },
    {
      title: '8. Prohibited Use',
      paragraphs: [
        'You agree not to:',
      ],
      list: [
        'Use the Service for any unlawful purpose',
        'Attempt to reverse-engineer, scrape, or extract data from the platform at scale',
        'Share account credentials with others',
        'Use automated tools to abuse the API or overload the infrastructure',
        'Resell or redistribute data obtained from the Service',
      ],
    },
    {
      title: '9. Intellectual Property',
      paragraphs: [
        'All content, code, design, and data on the platform are the property of Micropincher. You are granted a limited, non-exclusive, non-transferable licence to use the Service for personal purposes.',
        'You may not copy, reproduce, or redistribute any part of the platform without prior written consent.',
      ],
    },
    {
      title: '10. Limitation of Liability',
      paragraphs: [
        'To the maximum extent permitted by law, Micropincher and its operators shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, trading losses, or data loss.',
        'The Service is provided "as is" without warranties of any kind, express or implied. We do not guarantee uninterrupted availability of the Service.',
        'Our total liability for any claim shall not exceed the amount you paid for the Service in the 3 months preceding the claim.',
      ],
    },
    {
      title: '11. Changes to These Terms',
      paragraphs: [
        'We may update these Terms & Conditions at any time. Material changes will be communicated via email or a prominent notice in the application at least 14 days before taking effect.',
        'Continued use of the Service after changes take effect constitutes acceptance of the new terms.',
        `Current version: 1.0 — Last updated: 2026-02-23`,
      ],
    },
    {
      title: '12. Governing Law',
      paragraphs: [
        'These Terms are governed by the laws of the Czech Republic. Any disputes arising out of or in connection with',
        'these Terms shall first be attempted to be resolved through good-faith negotiation between the parties. If a',
        'dispute cannot be resolved by negotiation within 30 days, it shall be finally settled by binding arbitration',
        'under the Rules of the Arbitration Court attached to the Czech Chamber of Commerce and Agrarian Chamber of the',
        'Czech Republic (Rozhodčí soud při Hospodářské komoře České republiky), with the seat of arbitration in Prague,',
        'Czech Republic, conducted in the Czech or English language.  Notwithstanding the above, consumers residing in the',
        'European Union retain the right to bring claims before the competent courts of their country of residence in accordance',
        'with applicable EU consumer protection law.',
      ],
    },
    {
      title: '13. Contact',
      paragraphs: [
        'For questions about these Terms & Conditions, contact us at: info@micropincher.com',
      ],
    },
  ],
};

export default terms;
